$(function () {

  //disableAutocomplete();
  function disableAutocomplete() {
    $('input').each(function () {
      $(this).attr("autocomplete", "off");
    });
    //window.setTimeout(disableAutocomplete, 1000);
  }

  $(window).on('resize load', function () {
    resize();
  });

  document.onpaste = function (event) {
    var items = (event.clipboardData || event.originalEvent.clipboardData).items;
    console.log(JSON.stringify(items)); // will give you the mime types
    for (index in items) {
      var item = items[index];
      if (item.kind === 'file') {
        var blob = item.getAsFile();
        var reader = new FileReader();
        reader.onload = function (event) {
          $('#imgPaste').attr('src', event.target.result);
        }; 
        reader.readAsDataURL(blob);
      }
    }
  }

});


function resize() {
  window.setTimeout(() => {
    try {
      $('.main-content').scrollTop(0);
      var navHeight = $(".site-header").height();
      if (!navHeight) {
        navHeight = 0;
      }
      var mainHeight = $(window).height() - (navHeight + 6);
      var footerHeight = $("nav.footer").height();
      $(".page-content").css('min-height', (mainHeight - footerHeight) + 'px');
    }
    catch(rex)
    {
      console.log(rex.message);
    }
  }, 100);

}


